import React from 'react';

import * as Elements from './Version.elements';

const Version = props => <Elements.Container {...props} />;

export default Version;
